import React from 'react'
import './About.css'
import about_img from "../../assets/about.png"
import play_icon from "../../assets/edusity/play-icon.png"

const About = ({setPlayState}) => {


  return (
    <div className='about'>
        <div className='about-left'>
            <img src={about_img} alt='' className='about-img'/>
            <img src={play_icon} alt='' className='play-icon' onClick={()=>{setPlayState(true)}}/>
        </div>
        <div className='about-right'>
            <h3> ABOUT CHURCH </h3>
            <h2> Serving The Community and God</h2>
            <p>A United Methodist Church is a Christian denomination known for its welcoming, inclusive community, strong commitment to social justice, and emphasis on personal and spiritual growth. The church often has a traditional yet inviting architectural style, featuring a prominent steeple, cross, and simple sanctuary with pews arranged to encourage a sense of togetherness. Worship services typically blend contemporary and traditional elements, incorporating music, prayer, scripture readings, and a sermon aimed at inspiring faith and community engagement.</p>

            <p>The United Methodist Church emphasizes <em>faith in action</em>, encouraging members to be involved in outreach and service to those in need, both locally and globally. Key beliefs focus on grace, the love of God for all people, and the transformative power of Jesus Christ.</p>

            <p>Education and fellowship are important, with many churches offering Bible studies, children’s programs, and small groups for deeper connection. This commitment to community, inclusiveness, and compassionate service is central to the Methodist tradition and its approach to Christian life and worship.</p>

        </div>
    </div>
  )
}

export default About